import { createSelector } from 'reselect';
import { addDeliveryPriceToSDDSelector } from 'selectors/testTarget/offers/addDeliveryPriceToSDD/addDeliveryPriceToSDDSelector';

const showSelector = createSelector(addDeliveryPriceToSDDSelector, addDeliveryPriceToSDD => !!addDeliveryPriceToSDD.show);

export { showSelector };
